import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ColorChecklist = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
                fill: "#C3B3FC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.3105 8.87012C18.3105 9.28012 17.9805 9.62012 17.5605 9.62012H12.3105C11.9005 9.62012 11.5605 9.28012 11.5605 8.87012C11.5605 8.46012 11.9005 8.12012 12.3105 8.12012H17.5605C17.9805 8.12012 18.3105 8.46012 18.3105 8.87012Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.96957 7.90006L7.71957 10.1501C7.56957 10.3001 7.37957 10.3701 7.18957 10.3701C6.99957 10.3701 6.79957 10.3001 6.65957 10.1501L5.90957 9.40006C5.60957 9.11006 5.60957 8.63006 5.90957 8.34006C6.19957 8.05006 6.66957 8.05006 6.96957 8.34006L7.18957 8.56006L8.90957 6.84006C9.19957 6.55006 9.66957 6.55006 9.96957 6.84006C10.2596 7.13006 10.2596 7.61006 9.96957 7.90006Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.3105 15.8701C18.3105 16.2801 17.9805 16.6201 17.5605 16.6201H12.3105C11.9005 16.6201 11.5605 16.2801 11.5605 15.8701C11.5605 15.4601 11.9005 15.1201 12.3105 15.1201H17.5605C17.9805 15.1201 18.3105 15.4601 18.3105 15.8701Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.96957 14.9001L7.71957 17.1501C7.56957 17.3001 7.37957 17.3701 7.18957 17.3701C6.99957 17.3701 6.79957 17.3001 6.65957 17.1501L5.90957 16.4001C5.60957 16.1101 5.60957 15.6301 5.90957 15.3401C6.19957 15.0501 6.66957 15.0501 6.96957 15.3401L7.18957 15.5601L8.90957 13.8401C9.19957 13.5501 9.66957 13.5501 9.96957 13.8401C10.2596 14.1301 10.2596 14.6101 9.96957 14.9001Z",
                fill: "#6942F8"
            })
        ]
    });
};
